import { render, staticRenderFns } from "./TotalValuePay.vue?vue&type=template&id=06f6b462"
import script from "./TotalValuePay.vue?vue&type=script&lang=js"
export * from "./TotalValuePay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports